import img1 from '../images/team/1.jpg'
import img2 from '../images/team/2.jpg'
import img3 from '../images/team/3.jpg'
import img4 from '../images/team/4.jpg'
import img5 from '../images/team/5.jpg'
import img6 from '../images/team/6.jpg'


const TeamData = [
    {
        id: '01',
        title: 'Alextina Ditarson',
        subtitle: 'Transportation Planner',
        Imga: img1,
    },
    {
        id: '02',
        title: 'Leslie Alexander',
        subtitle: 'Supply Chain Manager',
        Imga: img2,
    },
    {
        id: '03',
        title: 'Brooklyn Simmons',
        subtitle: 'Logistics Coordinator',
        Imga: img3,
    },
    {
        id: '04',
        title: 'Marvin McKinney',
        subtitle: 'Warehouse Manager',
        Imga: img4,
    },
    {
        id: '05',
        title: 'Warehouse Manager',
        subtitle: 'Fleet Supervisor',
        Imga: img5,
    },
    {
        id: '06',
        title: 'Warehouse Manager',
        subtitle: 'Fleet Supervisor',
        Imga: img6,
    }
]

export default TeamData;